import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchAddJob, fetchDeleteJob, fetchJobs } from './jobsAPI';

const initialState = {
    jobs: [],
    loading: false,
    errorMessage: '',
    isError: '',

    postLoading: false,
    postErrorMessage: "",
    postIsError: false,

    deleteLoading: false,
};

export const getJobs = createAsyncThunk(
    'jobs/fetchJobs',
    async (filter) => {
        const data = await fetchJobs(filter);
        return data;
    }
);
export const addJob = createAsyncThunk(
    'jobs/addJob',
    async (data) => {
        const result = await fetchAddJob(data);
        return result;
    }
);
export const deleteJob = createAsyncThunk(
    'jobs/deleteJob',
    async (id) => {
        const result = await fetchDeleteJob(id);
        return result;
    }
);

export const jobsSlice = createSlice({
    name: 'job',
    initialState,

    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {
        builder
            .addCase(getJobs.pending, (state) => {
                state.loading = true;
                state.errorMessage = '';
                state.isError = false;
                state.jobs = [];

            })
            .addCase(getJobs.fulfilled, (state, action) => {
                state.loading = false;
                state.errorMessage = '';
                state.isError = false;
                state.jobs = action.payload;
            })
            .addCase(getJobs.rejected, (state, action) => {
                state.loading = false;
                state.errorMessage = action.error;
                state.isError = true;
                state.jobs = [];
            })

            .addCase(addJob.pending, (state, action) => {
                state.postLoading = true;
                state.postErrorMessage = '';
                state.postIsError = false;
            })
            .addCase(addJob.fulfilled, (state, action) => {
                state.postLoading = false;
                state.postErrorMessage = '';
                state.postIsError = false;
                state.jobs.push(action.payload);
            })
            .addCase(addJob.rejected, (state, action) => {
                state.postLoading = false;
                state.postErrorMessage = action.error.message
                state.postIsError = true;
            })

            .addCase(deleteJob.pending, (state, action) => {
                state.deleteLoading = true;
            })
            .addCase(deleteJob.fulfilled, (state, action) => {
                state.deleteLoading = false;
                state.jobs = state.jobs.filter(single => single.id !== action.meta.arg)
            })
            .addCase(deleteJob.rejected, (state, action) => {
                state.deleteLoading = false;
                console.log(action.error)
            })
    },
});


export default jobsSlice.reducer;